// GD Goenka University Json

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const universityBgImage = imageBaseUrl + "International-Relation/University/GdGoenka-University.jpeg";

const Fees_GDGU_Africa = imageBaseUrl + "International-Relation/University/fee-structure/Fees_GDGU_Africa.pdf";
const Fees_GDGU_Middle_East = imageBaseUrl + "International-Relation/University/fee-structure/Fees_GDGU_Middle East.pdf";
const Fees_GDGU_SAARC = imageBaseUrl + "International-Relation/University/fee-structure/Fees_GDGU_SAARC.pdf";

const k1 = imageBaseUrl + "universityKnow/k1.png";
const k2 = imageBaseUrl + "universityKnow/k2.png";
const k3 = imageBaseUrl + "universityKnow/k3.png";
const k4 = imageBaseUrl + 'universityKnow/k4.png'
const k5 = imageBaseUrl + "universityKnow/k5.png";
const k6 = imageBaseUrl + "universityKnow/k6.png";

const gurugram = imageBaseUrl + "International-Relation/University/gurugram.png";

export const gdGoenkaUniversityJson = {
  BannerData: {
    heading: "GD Goenka University",
    backgroundImage: universityBgImage,
    content: (
      <>
       GD Goenka University, established in 2013 in Gurugram, Haryana,
        is a private university known for its emphasis on innovation, research, and holistic education.
        It offers undergraduate, postgraduate, and doctoral programs across disciplines such as engineering,
        management, law, hospitality, and design. The university features state-of-the-art infrastructure,
        modern laboratories, and global collaborations with international institutions.
        With a focus on experiential learning, industry exposure, and entrepreneurship,
        GD Goenka University aims to nurture future leaders. It is part of the GD Goenka Group,
        which has a legacy in premium education.
        The university is recognized by UGC and accredited by various regulatory bodies.
      </>
    ),
  },

  // University Details
 

  universityDetails: [
      {
        id: 1,
        title: "Name",
        subtitle: "GD Goenka University",
        image: imageBaseUrl + "universityinfo/1.png",
      },
      {
        id: 2,
        title: "Location",
        subtitle: "Gurugram, Haryana, India",
        image: imageBaseUrl + "universityinfo/2.png",
      },
      {
        id: 3,
        title: "Founded",
        subtitle:"2013",
        image: imageBaseUrl + "universityinfo/3.png",
      },
      {
        id: 4,
        title: "Type",
        subtitle: "Private University",
        image: imageBaseUrl + "universityinfo/4.png",
      },
      {
        id: 5,
        title: "Total Enrollment",
        subtitle: "30,000+ students",
        image: imageBaseUrl + "universityinfo/5.png",
      },
      {
        id: 6,
        title: "International Students",
        subtitle: "Students from over 45 countries",
        image: imageBaseUrl + "universityinfo/6.png",
      },
      {
        id: 7,
        title: "Total Students",
        subtitle: "30,000+",
        image: imageBaseUrl + "universityinfo/6.png",
      },
  
      {
        id: 8,
        title: "Website",
        subtitle: "Strengthening international recognition and credibility",
        image: imageBaseUrl + "universityinfo/7.png",
        url: "https://www.gdgoenkauniversity.com/",
      },
    ],
  
  

  WhyChooseThisUniversityPage:[
    { id: 1, rank: "NAAC A+", title: (<><b>NAAC A+ Accreditation –</b> Recognized for academic excellence</>)},
    { id: 2, rank: "A+ Grade", title: (<>Ranked in the <b>Diamond Band</b> with <b>A+ Grade</b> in World Institutional <b>OBE Rankings 2023</b></>)},
    { id: 3, rank: "10th", title: (<><b>Ranked 10th</b> in Delhi-NCR among top private MBA institutions in <b>Outlook-ICARE Rankings 2023</b></>) },
  ],

  feeStructure: [
    { label: "Africa", value: "Africa", pdfFile: Fees_GDGU_Africa },
    { label: "Middle East", value: "Middle East", pdfFile: Fees_GDGU_Middle_East},
    { label: "SAARC", value: "Middle East", pdfFile: Fees_GDGU_SAARC},
  ],

KnowMore:[
  {
    title: "Campus Life",
    img: k1, 
    url: "https://www.gdgoenkauniversity.com/on-campus",
  },
  {
    title: "How to Apply",
    img: k2, 
    url: "https://www.gdgoenkauniversity.com/apply-now/",
  },
  {
    title: "International Students",
    img: k3, 
    url: "https://www.gdgoenkauniversity.com/international",
  },

  {
    title: "Accommodation",
    img: k5, 
    url: "https://www.galgotiasuniversity.edu.in/p/academics/hostelhttps://www.gdgoenkauniversity.com/admissions/hostel-fee-structure",
  },

  {
    title: "Placements statistics",
    img: k4, 
    url: "https://www.gdgoenkauniversity.com/gdgu-placement-highlights",
  },
   
  {
    title: "Brochure",
    img: k6, 
    url: "https://static.npfs.co/accounts/429/documents/2024/5/3/University%20-%20Admission%20Brochure%20-%2002.05.2024_compressed.pdf",
  },
],

Location:{
    header:"GURUGRAM",
    image: gurugram,
    content: (<>Gurugram is a thriving destination for international students, combining modern infrastructure, cultural diversity, and excellent career prospects.
    <br></br>
      <br></br>
      <ul style={{"margin-left": "20px"}}>
        <li><b>Top Universities</b></li>
        <li><b>Career Hub</b></li>
      <li><b>Vibrant Lifestyle</b></li>
      <li><b>Great Connectivity</b></li>
      <li><b>Safe & Multicultural</b></li>
      </ul>
      </>) },

    
};